import { all, call, fork, put, take } from 'redux-saga/effects'

import { fetchCmsMtoUpdate, fetchCmsDeliveryUpdate } from '../../actionCreators/cms/cmsActionCreators'
import { FETCH_CMS_MTO_REQUEST, FETCH_CMS_DELIVERY_REQUEST } from '../../actionTypes/cmsActionTypes'
import Logger from '../../helpers/Logger'

const logger = Logger.getInstance()

async function fetchMtoApi(path, payload) {
  const { url, key } = payload
  const endpoint = `${url}/content-library/v1/content-drawer/`

  try {
    const res = await fetch(`${endpoint}${path}.json`, {
      headers: {
        'x-api-key': key
      }
    })
    if (!res.ok) {
      logger.error('apiLogger', { path, status: res.status }, 'Fetching data from CMS failed to return 200.')
      return null
    }
    const json = await res.json()
    return json.data[0].attributes
  } catch (error) {
    logger.error('apiLogger', error, 'Error fetching data from CMS.')

    return null
  }
}

function* cmsMtoSaga(payload) {
  const pathPrefixes = ['handcrafted-to-your-needs', 'measure-before-you-order', 'mto-delivery-and-returns']
  const paths = pathPrefixes.map(path => `${path}-${payload.brand}`)

  const [handcraftedJson, measureJson, deliveryJson] = yield all(
    paths.map(path => {
      return call(fetchMtoApi, path, payload)
    })
  )

  yield put(
    fetchCmsMtoUpdate({
      handcrafted: handcraftedJson,
      measure: measureJson,
      delivery: deliveryJson
    })
  )
}
function* cmsDeliverySaga(payload) {
  const twoManDeliveryJson = yield call(fetchMtoApi, `two-man-delivery-and-returns-${payload.brand}`, payload)
  yield put(fetchCmsDeliveryUpdate(twoManDeliveryJson))
}

function* watchCmsSaga(payload) {
  while (true) {
    const action = yield take([FETCH_CMS_DELIVERY_REQUEST, FETCH_CMS_MTO_REQUEST])

    if (action.type === FETCH_CMS_MTO_REQUEST) {
      yield fork(cmsMtoSaga, payload)
    } else if (action.type === FETCH_CMS_DELIVERY_REQUEST) {
      yield fork(cmsDeliverySaga, payload)
    }
  }
}

export { cmsMtoSaga, watchCmsSaga, fetchMtoApi, cmsDeliverySaga }
